import { Form } from "@amzn/aquila-feedback-web-assets";
import { TextButton } from "@amzn/storm-ui";
import React, { useEffect, useState } from "react";
import { useStore } from "zustand";

import { useGetAllInsghtsTabReportIssueForm } from "../../hooks/aquila/reportIssue/useGetReportIssueForm/useGetAllInsghtsTabReportIssueForm";
import { useSubmitReportIssueForm } from "../../hooks/aquila/reportIssue/useSubmitReportIssueForm/useSubmitReportIssueForm";
import { authStore } from "../../store/auth";
import { AquilaReportIssueTriggerType } from "../../types/aquila";
import { isSuccess } from "../../utils/api.utils";

export const AccountPickerError: React.FC = () => {
    const [aquilaConfig] = useStore(authStore, (state) => [
        state.settings.aquilaConfig,
    ]);
    const [
        formConfig,
        formConfigAsyncStatus,
        getFormConfigAsyncAction,
        updateFormConfig,
    ] = useGetAllInsghtsTabReportIssueForm({
        reportIssueFormConfig: aquilaConfig.allInsightsTabReportIssueConfig,
    });
    const [isFeedbackFormOpen, setIsFeedbackFormOpen] = useState(false);
    const [, createFeedbackAsyncAction] = useSubmitReportIssueForm({
        reportIssueFormConfig: aquilaConfig.allInsightsTabReportIssueConfig,
        trigger: AquilaReportIssueTriggerType.ALL_INSIGHTS_TAB,
    });

    const handleOnSubmit = (formData) => {
        setIsFeedbackFormOpen(false);
        void createFeedbackAsyncAction.execute(formData);
    };

    const handleOnCancel = () => {
        setIsFeedbackFormOpen(false);
    };

    const handleReportIssue = () => {
        setIsFeedbackFormOpen(true);
    };

    const initialValues = {
        issueType: "Salesforce accounts issue",
    };

    useEffect(() => {
        if (aquilaConfig.allInsightsTabReportIssueConfig?.configId) {
            void getFormConfigAsyncAction.execute();
        }
    }, []);

    return (
        <div data-testid="account-picker-error">
            Something went wrong while fetching your account. Please follow this{" "}
            <a
                href="https://w.amazon.com/bin/view/Ads/Helios/Applications/InsightsHub/#HOverview26Roadmap"
                data-testid="mbob-link"
            >
                link
            </a>{" "}
            to access InsightsHub from MBob.
            <p style={{ marginTop: "16px" }}>
                Close this modal to land on Insights Hub's account agnostic
                view.
            </p>
            {isSuccess(formConfigAsyncStatus) && formConfig && (
                <div style={{ marginTop: "16px" }}>
                    <TextButton onClick={handleReportIssue}>
                        Report an Issue
                    </TextButton>
                    {isFeedbackFormOpen && (
                        <Form
                            {...formConfig}
                            configId={
                                aquilaConfig.allInsightsTabReportIssueConfig
                                    .configId
                            }
                            onSubmit={handleOnSubmit}
                            onCancel={handleOnCancel}
                            onFieldChange={updateFormConfig}
                            isOpen={isFeedbackFormOpen}
                            initialValues={initialValues}
                        />
                    )}
                </div>
            )}
        </div>
    );
};
